import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { ItemServicoDetalharRoutingModule } from "./item-servico-detalhar-routing.module";
import { ItemServicoDetalharComponent } from "./item-servico-detalhar.component";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { InputNumberModule } from "primeng/inputnumber";
import { TooltipModule } from "primeng/tooltip";
import { RippleModule } from "primeng/ripple";




@NgModule({
    imports: [
    CommonModule,
    ItemServicoDetalharRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    InputMaskModule,
    FormatPipeModule,
    ProgressSpinnerModule,
    MessagesModule,
    DialogModule,
    DividerModule,
    InputNumberModule,
    TooltipModule,
    RippleModule
],
    declarations: [ItemServicoDetalharComponent]
})
export class ItemServicoDetalharModule { }
